/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import config from "../config";

const OAUTH_CLIENT_ID_PRODUCTION = "cd3df99b-8f63-445d-9c83-8ef0679123ae";

export const isProduction = config.oauth.client_id === OAUTH_CLIENT_ID_PRODUCTION;

export function convertPointerToPathComponents(jsonPointer: string) {
  return jsonPointer.split("/").slice(1);
}
